import React from 'react';

import withPageComponents from '../../page/components/with-page-components';
import SeoMeta from '../../page/components/seo-meta';
import { getPDPTitle, getProductDescription } from '../seo-helpers';

const mapSEOData = (product, pdpImages, seo) => {
    const { mediumImages } = pdpImages || {};
    const title = getPDPTitle(product);
    const description = getProductDescription(product);
    const keywords = seo.keywords;
    const productImage = mediumImages?.[0]?.url;
    const ogData = {
        type: 'product',
        title: title,
        description: description,
        url: seo.canonical || product.linkUrl,
        image: productImage,
    };

    return {
        title,
        description,
        ...seo,
        keywords,
        canonical: seo.canonical || product.linkUrl,
        ogData,
    };
};

export default withPageComponents(
    ({ productInitial, pdpImages, seo, url }) => {
        if (productInitial) {
            return <SeoMeta seo={mapSEOData(productInitial, pdpImages, seo || {}, url)} />;
        }
        return null;
    },
    { components: ['productInitial', 'pdpImages'] },
);
